import { render, staticRenderFns } from "./Proformas.vue?vue&type=template&id=07100d3a&"
import script from "./Proformas.vue?vue&type=script&lang=js&"
export * from "./Proformas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports